import { AANAccountType } from '@interfaces/models';
import { Action, createReducer, on } from '@ngrx/store';
import { DecedentInfo } from '@sharedUtils/extract-name-from-string/extract-name-from-string';
import * as AccountRegistrationActions from '@store/actions/account-registrations/account-registrations.actions';

export interface AccountRegistrationsState {
  accountId: string;
  accountType: AANAccountType;
  registrationLines: string[];
  tin: string;
}

export interface AccountRegistrationsStateWithBenef extends AccountRegistrationsState {
  benefName: Pick<DecedentInfo, 'firstName' | 'lastName' | 'middleName' | 'suffix'>;
}

export const initialState: AccountRegistrationsState[] = [];

const accountRegistrationsReducer = createReducer(
  initialState,
  on(AccountRegistrationActions.UpdateAccountRegistrations, (state, prop) => [...prop.payload]),
);

export function reducer(state: AccountRegistrationsState[] | undefined, action: Action) {
  return accountRegistrationsReducer(state, action);
}
